import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { hexToRGB } from '../../utils';
import { SELECTION_BUTTON_MIN_WIDTH } from './constants';
export const concessionIconPartialCSS = css `
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`;
const sizePartialCSS = ({ theme, size, }) => size === 'xlarge' &&
    css `
    height: 60px;
    padding: ${theme.space[6]} ${theme.space[7]} ${theme.space[6]}
      ${theme.space[8]};
    font-size: ${theme.space[6]} ${theme.fontSizes[5]};
    line-height: ${theme.space[6]} ${theme.lineHeights[3]};
  `;
const goalPartialCSS = ({ theme, selection: { isGoal }, }) => isGoal &&
    css `
    background: ${theme.colors.interactions.primaryCTA.default};
  `;
const interactionTheme = (theme, isUpdating) => css `
  background: ${isUpdating ? hexToRGB(theme.default, 0.9) : theme.default};
  color: ${theme.text.default};
  border-color: ${theme.border.default};
  svg {
    fill: ${theme.text.default};
  }

  &:hover {
    background: ${theme.hover};
    color: ${theme.text.hover};
    border-color: ${theme.border.hover};
    svg {
      fill: ${theme.text.default};
    }
  }
  &:focus {
    background: ${theme.focus};
    color: ${theme.text.focus};
    border-color: ${theme.border.focus};
    svg {
      fill: ${theme.text.focus};
    }
  }
  &:active {
    background: ${theme.active};
    color: ${theme.text.active};
    border-color: ${theme.border.active};
    svg {
      fill: ${theme.text.active};
    }
  }
`;
// eslint-disable-next-line complexity
const selectionThemePartialCSS = ({ selection, isEnhanced, isFlashOdds, isDoubleYourOdds, isSuperOdds, isUpdating, isAlwaysOnFlashOdds, theme, }) => {
    const { isAdding, isRemoving, isProcessing, isAdded } = selection;
    const isConcession = isEnhanced || isFlashOdds || isSuperOdds || isDoubleYourOdds;
    const isActive = isAdding || isRemoving || isProcessing || isAdded;
    if (isActive) {
        return interactionTheme(theme.colors.interactions.oddsActive, isUpdating);
    }
    if (isConcession) {
        return interactionTheme(theme.colors.interactions.oddsConcession, isUpdating);
    }
    if (isAlwaysOnFlashOdds) {
        return interactionTheme(theme.colors.interactions.oddsFlash, isUpdating);
    }
    return interactionTheme(theme.colors.interactions.oddsCTA, isUpdating);
};
const suspendedPartialCSS = ({ selection: { isSuspended }, }) => isSuspended &&
    css `
    pointer-events: none;
    opacity: 0.5;
  `;
export const CustomBottomText = styled.div `
  font-weight: 400;
  font-size: 11px;
  padding-top: 5px;
  letter-spacing: 0.004em;
  color: #7383a6;
`;
const StyledSelectionButton = styled.button `
  position: relative;
  vertical-align: middle;
  box-sizing: border-box;
  justify-content: center;
  min-width: ${SELECTION_BUTTON_MIN_WIDTH}px;
  height: ${({ theme }) => (theme.device === 'mobile' ? '44px' : '32px')};
  padding: ${({ theme }) => theme.device === 'mobile'
    ? '0'
    : `${theme.space[3]} 0`};
  font: inherit;
  font-size: ${({ theme }) => theme.fontSizes[0]};
  line-height: ${({ theme }) => theme.lineHeights[0]};
  font-weight: normal;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  border-radius: ${({ theme }) => theme.radii[1]};
  transition: background 0.2s ease-in, color 0.2s ease-in,
    border-color 0.2s ease-in;
  will-change: background, color;
  border: none;
  border-width: 1px;
  border-style: solid;

  span {
    line-height: inherit;
  }

  span + span {
    margin-left: ${({ theme }) => theme.space[2]};
  }

  svg + span {
    margin-left: ${({ theme }) => theme.space[5]};
  }

  ${selectionThemePartialCSS}
  ${sizePartialCSS}
  ${goalPartialCSS}
  ${suspendedPartialCSS}
  ${({ expanded }) => expanded && 'width: 100% !important'}
`;
export default StyledSelectionButton;
